/**
 * Role utilities and view-toggle helpers.
 *
 * Roles (server-side `role` field):
 *   super_admin  — full access + /system
 *   admin        — welfare admin (manages welfare ops, no /system)
 *   treasurer    — contributions, payments, reports
 *   secretary    — members workflow, obituaries, announcements, areas
 *   member       — dashboard only
 */

export const ADMIN_ROLES = ["super_admin", "admin", "treasurer", "secretary"];

export function isAdmin(user) {
  return !!user && ADMIN_ROLES.includes(user.role);
}

export function isSuperAdmin(user) {
  return !!user && user.role === "super_admin";
}

export function isWelfareAdmin(user) {
  return !!user && user.role === "admin";
}

export function roleLabel(role) {
  return (
    {
      super_admin: "Super Admin",
      admin: "Welfare Admin",
      treasurer: "Treasurer",
      secretary: "Secretary",
      member: "Member",
    }[role] || role
  );
}

export function roleColor(role) {
  return (
    {
      super_admin: "bg-amber-500 text-slate-900",
      admin: "bg-white/20 text-white",
      treasurer: "bg-emerald-500 text-white",
      secretary: "bg-indigo-500 text-white",
      member: "bg-slate-200 text-slate-800",
    }[role] || "bg-muted text-muted-foreground"
  );
}

/**
 * Returns which tabs the given admin role should see in /admin.
 * Super admin & Welfare admin see all; treasurer/secretary see a subset.
 */
export function visibleAdminTabs(role) {
  if (role === "super_admin" || role === "admin") {
    return ["pending", "workflow", "members", "bereavements", "areas", "announcements", "banking", "wallets", "payments", "reminders", "reports", "team", "settings"];
  }
  if (role === "treasurer") {
    return ["bereavements", "members", "banking", "wallets", "payments", "reminders", "reports"];
  }
  if (role === "secretary") {
    return ["pending", "workflow", "members", "bereavements", "areas", "announcements", "reminders"];
  }
  return [];
}

/** Default landing inside /admin for each admin role. */
export function defaultAdminTab(role) {
  if (role === "treasurer") return "banking";
  if (role === "secretary") return "pending";
  return "pending";
}
